import { Transition } from "@uirouter/core";
import { SnugHomeToolbarController } from "../snugHome-toolbar.controller";

export class SnugHomeJournalToolbarController extends SnugHomeToolbarController {
    constructor(
        $injector: angular.auto.IInjectorService,
        $transition: Transition,
    ) {
        super($injector, $transition, {
            viewType: "journal",
        });
    }
}
